module.exports = __webpack_public_path__ + "img/user.c805552e.jpg";